{
    "NAME": "LogManagementListLanguage",
    "LogManagementList_Column_Name": "Log File",
    "LogManagementList_Column_ClassName": "For Class",
    "LogManagementList_Column_FileName": "Filename",
    "LogManagementList_Column_FileSize": "File Size",
    "LogManagementList_Column_Status": "Status",
    "LogManagementList_Status_Running": "Running",
    "LogManagementList_Status_NotRunning": "Not Running",
    "LogManagementList_Action_Start": "Start",
    "LogManagementList_Action_Stop": "Stop",
    "LogManagementList_Action_Reset": "Reset",
    "LogManagementList_Action_Download": "Download",
    "LogManagementList_SearchPlaceholder": "[Log File]",
    "LogManagementList_Empty": "No logging items are currently being shown which probably signifies a critical application or internal component initialisation problem.",
    "LogManagementList_Confirm_ResetTitle": "Reset log files",
    "LogManagementList_Confirm_ResetBody": "Warning: Choosing to reset log file item(s) will delete the corresponding file(s), which is an unrecoverable operation.",
    "LogManagementList_Confirm_StopTitle": "Stop logging",
    "LogManagementList_Confirm_StopBody": "Choosing to temporarily stop logging output being generated into the selected log file(s) should only be performed when you need to freeze the corresponding file(s) in special situations.",
    "LogManagementList_Confirm_Generic": "Are you sure wish to continue and perform the selected action?"
}
